module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADNSURBVDhPzZJNDgFBEEZnxUJcgMvgOIItEntu43dv52chxFHEAXxvqke66Z7ZiZe8pKYnU1PVVdlfUpMjeZZP59Gd8a6UtrzJpezIhpOYs6tsySh1eZfj/MmYyLmFOVNJkmgllLiy8M1nAtjIgYUhJ0mpPrEEXcmdfMFl0a8PCfaStorWmvJhYUgsARUtPCGZgLIor4pkC0O5trCUrexbGMIY2QFGlWImLzK5UCwJc+YvlEq/2JM7ycfJRSogO3M+SC4LiSm7cpV/TZa9ACiMKRkdX40mAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Grey/Clock16.png
// module id = 671
// module chunks = 0